import { render, staticRenderFns } from "./pollutant-dialog.vue?vue&type=template&id=d7962fc0&scoped=true&"
import script from "./pollutant-dialog.vue?vue&type=script&lang=js&"
export * from "./pollutant-dialog.vue?vue&type=script&lang=js&"
import style0 from "./pollutant-dialog.vue?vue&type=style&index=0&id=d7962fc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7962fc0",
  null
  
)

export default component.exports